import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ItemView from '../utils/ItemView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Enums from '../../enums';

class GoodsCreateApp extends React.Component {
    //0=抽獎, 1=點數兌換, 2=現 點數換購
    E_TYPE = {
        LOTTERY: 0,
        POINT: 1,
        MONEY: 2
    };

    constructor() {
        super();
        Tools.init();
        API.init(this);

        let tomorrowDateTime = new Date();
        tomorrowDateTime = tomorrowDateTime.setDate(tomorrowDateTime.getDate() + 1);
        const tmp = [
            {
                type: Enums.E_ITEM.OPTION,
                data: {
                    label: "禮物類型",
                    neccessary: true,
                    value: 0,
                    options: [
                        [0, "抽獎"],
                        [1, "直接換"],
                        [2, "換購"]
                    ]
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "中獎人數",
                    neccessary: true,
                    value: 10
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "E幣",
                    neccessary: true,
                    value: 7
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                data: {
                    label: "禮物名稱",
                    neccessary: true,
                    value: "這是名稱"
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "金幣",
                    value: 7
                }
            }, {
                type: Enums.E_ITEM.TIME,
                data: {
                    label: "上架日期",
                    neccessary: true,
                    value: new Date().getTime()
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "禮物數量",
                    neccessary: true,
                    value: 8
                }
            }, {
                type: Enums.E_ITEM.TIME,
                data: {
                    label: "下架日期",
                    neccessary: true,
                    value: tomorrowDateTime
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "兌換次數限制",
                    value: 9
                }
            }, {
                type: Enums.E_ITEM.TIME,
                data: {
                    label: "開獎日期",
                    value: new Date().getTime()
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                data: {
                    label: "商品類型",
                    neccessary: true,
                    col: 1,
                    value: "0"
                }
                // type: Enums.E_ITEM.OPTION,
                // col: 1,
                // data: {
                //     label: "商品類型",
                //     value: 0,
                //     options: [
                //         [0, "0?"],
                //         [1, "1?"]
                //     ]
                // }
            }, {
                type: Enums.E_ITEM.RADIO,
                data: {
                    label: "置頂",
                    value: 0,
                    options: [
                        [1, "是"],
                        [0, "否"]
                    ]
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                col: 1,
                data: {
                    label: "委託業主",
                    value: "業主1"
                }
            }, {
                type: Enums.E_ITEM.RADIO,
                data: {
                    label: "強力推薦",
                    value: 0,
                    options: [
                        [1, "是"],
                        [0, "否"]
                    ]
                }
            }, {
                type: Enums.E_ITEM.RADIO,
                data: {
                    label: "刪除",
                    value: 0,
                    options: [
                        [1, "是"],
                        [0, "否"]
                    ]
                }
            }, {
                type: Enums.E_ITEM.OPTION,
                col: 1,
                data: {
                    label: "兌換類型",
                    neccessary: true,
                    value: 0,
                    options: [
                        [0, "僅序號"],
                        [1, "連結及通行碼"]
                    ]
                }
            }, {
                type: Enums.E_ITEM.TEXTAREA,
                col: 1,
                data: {
                    label: "禮物說明",
                    neccessary: true,
                    value: "這是禮物說明"
                }
            }, {
                type: Enums.E_ITEM.IMAGE,
                data: {
                    label: "禮物副圖",
                    neccessary: true,
                    value: "https://www.innovatorsmag.com/wp-content/uploads/2018/02/matt-hardy-562566-750x400.jpg"
                }
            }, {
                type: Enums.E_ITEM.IMAGE,
                data: {
                    label: "禮物主圖",
                    value: "http://assets.stickpng.com/thumbs/585e4beacb11b227491c3399.png"
                }
            }, {
                type: Enums.E_ITEM.TEXTAREA,
                col: 1,
                data: {
                    label: "兌換序號組",
                    neccessary: true,
                    value: JSON.stringify([{ "key": "兌換序號組", "pw": "通行碼" }])
                }
            }

            // {
            //     type: Enums.E_ITEM.NUMBER,
            //     col: 1,
            //     data: {
            //         label: "最多抽獎人數",
            //         neccessary: true,
            //         value: 10
            //     }
            // }, 
        ];
        switch (tmp[0].data.value) {
            case 1:
            case "1":
                tmp[8].hide = false; //roll_at
                tmp[13].hide = false; //max_people
                delete tmp[19].hide;
                break;
            case 0:
            case "0":
                delete tmp[8].hide;
                delete tmp[13].hide;
                tmp[19].hide = false; //serials
        }

        this.state = {
            list: tmp
        };

        this.onItemViewUpdated = this.onItemViewUpdated.bind(this);
        this.onPreview = this.onPreview.bind(this);
        this.onSave = this.onSave.bind(this);
        this.checkNecessary = this.checkNecessary.bind(this);
    };

    onItemViewUpdated(index, value) {
        // console.log(index,value);
        let list = Object.assign({}, this.state.list);
        list[index].data.value = value;
        if (0 == index) {
            switch (value) {
                case 1:
                case "1":
                    list[9].hide = true; //抽獎時間 roll_at
                    list[6].hide = true; //禮物數量 good_num
                    list[1].hide = true; //參加人數限制 max_people
                    delete list[19].hide;
                    break;
                case 0:
                case "0":
                    delete list[9].hide;
                    delete list[6].hide;
                    delete list[1].hide;
                    list[19].hide = true; //serials
                    break;
                case 2:
                case "2":
                    list[9].hide = true; //抽獎時間 roll_at
                    list[6].hide = true; //禮物數量 good_num
                    list[1].hide = true; //參加人數限制 max_people
                    list[19].hide = true; //serials
                    break;
            }
        }
        this.setState({ list: list });
    }

    checkNecessary() {
        let list = Object.assign({}, this.state.list),
            result = true;
        for (let i in list) {
            let obj = list[i];
            delete obj.data.isError;
            if (true == obj.data.neccessary) {
                if (null == obj.data.value) {
                    result = false;
                    obj.data.isError = true;
                }
                switch (obj.type) {
                    case Enums.E_ITEM.TEXT:
                    case Enums.E_ITEM.TEXTAREA:
                        if (typeof (obj.data.value) != "string" ||
                            0 == obj.data.value.length
                        ) {
                            result = false;
                            obj.data.isError = true;
                        }
                        break;
                    case Enums.E_ITEM.TIME:
                    case Enums.E_ITEM.NUMBER:
                        if (isNaN(parseInt(obj.data.value))
                        ) {
                            result = false;
                            obj.data.isError = true;
                        }
                        break;
                }
            }
        }
        this.setState({ list: list });
        return result;
    }

    onPreview() {
        if (false == this.checkNecessary()) {
            alert("資料錯誤");
            return;
        }
        console.log("onPreview");
        const list = this.state.list;
        const header = {
            ty: 1, //功能(0=新增, 1=預覽, 2=修改)
        };
        const body = {
            "type": list[0].data.value,        // 兌換類型(0=抽獎, 1=點數兌換, 2=現⾦金金點數換購), 
            "max_people": list[1].data.value,  //type0: 最多抽獎⼈人數,
            "point": list[2].data.value,       //所需點數,
            "name": list[3].data.value,        //"商品名稱",
            "cash_point": list[4].data.value,  //所需現⾦金金點,
            "start_at": list[5].data.value,    //起始時間(Timemillis), 
            "goods_num": list[6].data.value,   //商品數量量,
            "end_at": list[7].data.value,      //結束時間(Timemillis),
            "max_roll": list[8].data.value,    //每⼈人最多兌換次數,
            "roll_at": list[9].data.value,     //type0: 抽獎時間(Timemillis)
            "g_type": list[10].data.value,      //商品類型,
            "is_top": list[11].data.value,      //(0/1)是否置頂,
            "source": list[12].data.value,      //"委託業主",
            "is_recom": list[13].data.value,    //(0/1)是否推薦,
            "is_del": list[14].data.value,      //(0/1)是否刪除,
            "recv_type": list[15].data.value,   //領取⽅方式(0=純序號, 1=連結及通⾏行行碼), 
            "description": list[16].data.value, //"商品敘述", 
            "images": [list[17].data.value],      //["圖片組連結"],
            "icon": list[18].data.value,        //"圖⽰示連結"
            "serials": list[19].data.value,        //"兌換用序號組"
        };
        console.log(JSON.stringify(list));
        console.log(body);
        API.AddGood(header, body, function (res) {
            console.log(res);
            if (22000 == res.code) {
                alert("測試成功");
                // location.reload();
            }
        });
    }

    onSave() {
        if (false == this.checkNecessary()) {
            alert("資料錯誤");
            return;
        }
        console.log("onSave");
        const list = this.state.list;
        const header = {
            ty: 0, //功能(0=新增, 1=預覽, 2=修改)
        };
        const body = {
            "type": list[0].data.value,        // 兌換類型(0=抽獎, 1=點數兌換, 2=現⾦金金點數換購), 
            "max_people": list[1].data.value,  //type0: 最多抽獎⼈人數,
            "point": list[2].data.value,       //所需點數,
            "name": list[3].data.value,        //"商品名稱",
            "cash_point": list[4].data.value,  //所需現⾦金金點,
            "start_at": list[5].data.value,    //起始時間(Timemillis), 
            "goods_num": list[6].data.value,   //商品數量量,
            "end_at": list[7].data.value,      //結束時間(Timemillis),
            "max_roll": list[8].data.value,    //每⼈人最多兌換次數,
            "roll_at": list[9].data.value,     //type0: 抽獎時間(Timemillis)
            "g_type": list[10].data.value,      //商品類型,
            "is_top": list[11].data.value,      //(0/1)是否置頂,
            "source": list[12].data.value,      //"委託業主",
            "is_recom": list[13].data.value,    //(0/1)是否推薦,
            "is_del": list[14].data.value,      //(0/1)是否刪除,
            "recv_type": list[15].data.value,   //領取⽅方式(0=純序號, 1=連結及通⾏行行碼), 
            "description": list[16].data.value, //"商品敘述", 
            "images": [list[17].data.value],      //["圖片組連結"],
            "icon": list[18].data.value,        //"圖⽰示連結"
            "serials": list[19].data.value,        //"兌換用序號組"
        };
        console.log(body);
        API.AddGood(header, body, function (res) {
            console.log(res);
            if (22000 == res.code) {
                alert("創建成功");
                // this.forceUpdate();
            } else {
                try {
                    alert(res.msg);
                } catch (e) { }
            }
        }, function (data) {
            try {
                alert(data.responseJSON.msg)
            } catch (e) { }
        });
    }

    // onDataUpdated(data) {
    //     console.log(this);
    //     if (data && data.data) {
    //         console.log(data);
    //         const tmp = [];
    //         for (let index in data.data) {
    //             const tmpObj = data.data[index];
    //             tmp.push({
    //                 key: tmpObj.accID,
    //                 data: [
    //                     tmpObj.accID,
    //                     tmpObj.m_nick,
    //                     tmpObj.m_gender,
    //                     tmpObj.m_age,
    //                     tmpObj.m_mobile
    //                 ]
    //             });
    //         }
    //         this.setState({
    //             list: tmp
    //         })
    //     }
    // }

    render() {
        const { onItemViewUpdated, onPreview, onSave } = this;
        const { list } = this.state;
        const E_TYPE = Enums.E_ITEM;

        const option_ary = [];
        for (var key in E_TYPE) {
            option_ary.push(<option key={key} value={E_TYPE[key]}>{key}</option>);
        }


        return (
            <div>
                <ItemView
                    title={"新增禮物"}
                    onUpdate={onItemViewUpdated}
                    onPreview={onPreview}
                    onSave={onSave}
                    data={list}
                    enabled={true}
                    disableDelete={true}
                    disableEdit={true} />
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(GoodsCreateApp),
//     document.getElementById('root')
// );

const mapStateToProps = (state) => ({
    id: state.authReducer.id,
    ac: state.authReducer.ac,
    tk: state.authReducer.tk
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(GoodsCreateApp))

                // <div>
                //     <h1>Create Lottery Gift</h1>

                //     <form className="form-horizontal">
                //         <div className="row">
                //             {/* 禮物類型 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">禮物類型*</label>
                //                 <div className="col-sm-8">
                //                     <select className="form-control" value={type}>
                //                         {option_ary}
                //                     </select>
                //                 </div>
                //             </div>
                //             {/* E幣 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">E幣*</label>
                //                 <div className="col-sm-8">
                //                     <input type="number" className="form-control" />
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row">
                //             {/* 禮物名稱 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">禮物名稱*</label>
                //                 <div className="col-sm-8">
                //                     <input type="text" className="form-control" />
                //                 </div>
                //             </div>
                //             {/* 金幣 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">金幣</label>
                //                 <div className="col-sm-8">
                //                     <input type="number" className="form-control" />
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row">
                //             {/* 上架日期 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">上架日期*</label>
                //                 <div className="col-sm-8">
                //                     <div className='input-group date datetimepicker'>
                //                         <input type='text' className="form-control" />
                //                         <span className="input-group-addon">
                //                             <span className="glyphicon glyphicon-calendar"></span>
                //                         </span>
                //                     </div>
                //                 </div>
                //             </div>
                //             {/* 禮物數量 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">禮物數量*</label>
                //                 <div className="col-sm-8">
                //                     <input type="number" className="form-control" />
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row">
                //             {/* 下架日期 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">下架日期*</label>
                //                 <div className="col-sm-8">
                //                     <div className='input-group date datetimepicker'>
                //                         <input type='text' className="form-control" />
                //                         <span className="input-group-addon">
                //                             <span className="glyphicon glyphicon-calendar"></span>
                //                         </span>
                //                     </div>
                //                 </div>
                //             </div>
                //             {/* 兌換次數限制 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">兌換次數限制</label>
                //                 <div className="col-sm-8">
                //                     <input type="number" className="form-control" />
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row">
                //             {/* 開獎日期 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">開獎日期*</label>
                //                 <div className="col-sm-8">
                //                     <div className='input-group date datetimepicker'>
                //                         <input type='text' className="form-control" />
                //                         <span className="input-group-addon">
                //                             <span className="glyphicon glyphicon-calendar"></span>
                //                         </span>
                //                     </div>
                //                 </div>
                //             </div>
                //             {/* 商品類型 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">商品類型*</label>
                //                 <div className="col-sm-8">
                //                     <select className="form-control" value={type}>
                //                         <option value="g_type">g_type</option>
                //                     </select>
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row">
                //             {/* 置頂 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">置頂</label>
                //                 <div className="col-sm-8">
                //                     <div className="radio">
                //                         <label>
                //                             <input type="radio" name="op_top" value="true"/>是
                //                         </label>
                //                     </div>
                //                     <div className="radio">
                //                         <label>
                //                             <input type="radio" name="op_top" value="false"/>否
                //                         </label>
                //                     </div>
                //                 </div>
                //             </div>
                //             {/* 委託業主 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">委託業主*</label>
                //                 <div className="col-sm-8">
                //                     <input type="text" className="form-control" />
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row">
                //             {/* 強力推薦 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">強力推薦</label>
                //                 <div className="col-sm-8">
                //                     <div className="radio">
                //                         <label>
                //                             <input type="radio" name="op_recommend" value="true"/>是
                //                         </label>
                //                     </div>
                //                     <div className="radio">
                //                         <label>
                //                             <input type="radio" name="op_recommend" value="false"/>否
                //                         </label>
                //                     </div>
                //                 </div>
                //             </div>
                //             {/* 最多抽獎人數 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">最多抽獎人數*</label>
                //                 <div className="col-sm-8">
                //                     <input type="number" className="form-control" />
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row">
                //             {/* 刪除 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">刪除</label>
                //                 <div className="col-sm-8">
                //                     <div className="radio">
                //                         <label>
                //                             <input type="radio" name="op_delete" value="true"/>是
                //                         </label>
                //                     </div>
                //                     <div className="radio">
                //                         <label>
                //                             <input type="radio" name="op_delete" value="false"/>否
                //                         </label>
                //                     </div>
                //                 </div>
                //             </div>
                //             {/* 兌換類型 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">兌換類型*</label>
                //                 <div className="col-sm-8">
                //                     <select className="form-control" value={type}>
                //                         <option value="recv_type">recv_type</option>
                //                     </select>
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row">
                //             {/* 禮物說明 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">禮物說明*</label>
                //                 <div className="col-sm-8">
                //                     <textarea type="text" className="form-control"></textarea>
                //                 </div>
                //             </div>
                //             {/* 禮物副圖 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">禮物副圖*</label>
                //                 <div className="col-sm-8">
                //                     <input type="file" className="form-control" />
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row">
                //             {/* 禮物主圖 */}
                //             <div className="form-group col-sm-6">
                //                 <label className="col-sm-4 control-label">禮物主圖*</label>
                //                 <div className="col-sm-8">
                //                     <input type="file" className="form-control" />
                //                 </div>
                //             </div>
                //         </div>


                //         <div className="row">
                //             <div className="form-group col-sm-6">
                //                 <div className="col-sm-12 col-sm-offset-4">
                //                     <button type="submit" className="btn btn-success">預覽</button>&nbsp;
                //                     <button type="submit" className="btn btn-success">儲存</button>&nbsp;
                //                     <button type="submit" className="btn btn-success">修改</button>
                //                 </div>
                //             </div>
                //         </div>
                //     </form>

                // </div>